import koLocale from 'element-ui/lib/locale/lang/ko'
const ko_kr = {
    ...koLocale
}

export default ko_kr
